import {validate} from 'chinese-idcard-checker';
export const columns = [
    {dataIndex:"id",key:"id",title:"序号",scopedSlots: { customRender: 'tindex' }},
    {dataIndex:"wxname",key:"wxname",title:"微信昵称"},
    {dataIndex:"username",key:"username",title:"姓名"},
    {dataIndex:"idcard",key:"idcard",title:"身份证号"},
    {dataIndex:"phonenum",key:"phonenum",title:"手机号"},
    {dataIndex:"cmpid",key:"cmpid",title:"所属公司",myRender:"company",scopedSlots: { customRender: 'company' }},
    {key:"action",title:"操作",scopedSlots: { customRender: 'action' }},
]

export const requires = [
	{"value":"username","text":"姓名"},
	{"value":"idcard","text":"身份证号码",checkfn:(text)=>validate(text)},
	{"value":"phonenum","text":"手机号码",checkfn:(text)=>{
		let reg = /^1[0-9]{10}$/
		return reg.test(text)
	}},
	{"value":"cmpid","text":"公司"},
	{"value":"wxcode","text":"微信号"},
]

export const saveinputs =[
	{name:"username",title:"姓名"},
	{name:"idcard",title:"身份证号"},
	{name:"phonenum",title:"电话号码"},
	{name:"wxname",title:"微信昵称"},
	{name:"wxcode",title:"微信号"},
]



// cmpid:{
// 	comment:"公司ID",
// },
// username:{
// 	comment:"用户名"
// },
// idcard:{
// 	comment:"身份证号码"
// },
// phonenum:{
// 	comment:"电话号码"
// },
// wxname:{
// 	comment:"微信昵称"
// },
// wxcode:{
// 	allowNull:false
// },
// imgUrl:{
// 	type:DataTypes.STRING(),
// },


// 姓名	
// 身份证号	身份证号校验
// 手机号	手机号校验
// 所属公司	下拉框选择，读取所有公司数据

// 编号
// 微信昵称
// 姓名
// 身份证号
// 手机号
// 所属公司